// client/src/components/TiptapEditor/MenuBar/MenuBar.js
import React from "react";
import {
  FormattingGroup,
  BlockStyleGroup,
  HistoryGroup,
  ListGroup,
  AlignmentGroup,
  LinkGroup,
  FontFamilyGroup,
  FontSizeGroup,
  ImageGroup, // <-- 1. IMPORTA EL NUEVO GRUPO
} from "./";

export const MenuBar = ({ editor }) => {
  if (!editor) {
    return null;
  }

  return (
    <div className="tiptap-menu-bar">
      <HistoryGroup editor={editor} />
      <FormattingGroup editor={editor} />
      <BlockStyleGroup editor={editor} />
      <AlignmentGroup editor={editor} />
      <ListGroup editor={editor} />
      <LinkGroup editor={editor} />
      <ImageGroup editor={editor} />
      <FontFamilyGroup editor={editor} />
      <FontSizeGroup editor={editor} />
    </div>
  );
};
